import { Fragment } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Box, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { Cancel } from '@mui/icons-material'
import { DeviceForm } from '../components/forms/DeviceForm'
import { Device } from '../types/models'
import { callAxios } from '../hooks/useAxios'
import { useApp } from '../hooks/useApp'
import { TopTitle } from '../components/atoms/TopTitle'

export function AdminAddDevicePage(): React.ReactElement {

  const navigate = useNavigate()
  const app = useApp()
  const { t } = useTranslation()

  const onSubmit = (device: Partial<Device>): void => {
    callAxios({
      method: 'POST',
      url: '/devices',
    }, device).then(res => {
      if (res.success) {
        navigate('/admin/devices')
        app.addInfo(t('Device created successfully.'))
      } else {
        app.addError(res)
      }
    })
  }

  return (
    <Fragment>
      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <TopTitle title={t('Add Device')}/>
        <Button color="error" variant="outlined" onClick={() => navigate('/admin/devices')} endIcon={<Cancel/>}>
          <Trans>Cancel</Trans>
        </Button>
      </Box>
      <DeviceForm new onSubmit={onSubmit}/>
    </Fragment>
  )
}
